export function assertUnreachable(x) {
    throw new Error(x);
}
//# sourceMappingURL=assertUnreachable.js.map